<template>
  <v-row row wrap class="ma-0">
    <template v-if="!$store.state.onlyAnnual">
      <v-col :cols="12" class="d-flex">
      <span class="text-h6 mx-auto">
        Pick a plan
      </span>
      </v-col>
      <v-col :cols="10" :offset="1" :sm="5" :offset-sm="1" :md="4" :offset-md="2" v-if="!loading" @click="planPicked(annualPlan)" :elevation="selectedPlan === annualPlan.value ? 24 : 6" style="cursor: pointer;">
        <div class="text-center subtitle-1 white--text plan-type pt-1" :class="selectedPlan === annualPlan.value ? (continueLoading ? 'loading' : 'chosen') : ''">
          Annual Plan
        </div>
        <div class="accent-border pa-2 text-center text-body-1 font-weight-black d-flex" :class="selectedPlan === annualPlan.value ? (continueLoading ? 'loading' : 'chosen') : ''">
          <div class="mx-auto my-auto">
            <div class="text-h6 font-weight-medium"><span>{{animatedLocalizedAnnualPrice}}</span><span class="caption">&nbsp;/&nbsp;year</span></div>
            <div class="caption text-sm-body-2 font-italic" style="color: gray;">{{annualPlan.subtext}}</div>
          </div>
        </div>
      </v-col>

      <v-col :cols="10" :offset="1" :sm="5" :offset-sm="0" :md="4" v-if="!loading" @click="planPicked(monthlyPlan)" :elevation="selectedPlan === monthlyPlan.value ? 24 : 6"  style="cursor: pointer;">
        <div class="text-center subtitle-1 white--text plan-type pt-1" :class="selectedPlan === monthlyPlan.value ? (continueLoading ? 'loading' : 'chosen') : ''">
          Monthly Plan
        </div>
        <div class="accent-border pa-2 text-center text-body-1 font-weight-black d-flex"
             :class="selectedPlan === monthlyPlan.value ? (continueLoading ? 'loading' : 'chosen') : ''"
        >
          <div class="mx-auto my-auto">
            <div class="text-h6 font-weight-medium my-auto mx-auto"><span>{{animatedLocalizedMonthlyPrice}}</span><span class="caption">&nbsp;/&nbsp;month</span></div>
            <div class="caption text-sm-body-2 font-italic" style="color: gray;">{{monthlyPlan.subtext}}</div>
          </div>
        </div>
      </v-col>

      <v-fade-transition>
        <v-alert type="info" color="warning" v-if="selectedPlan && selectedPlan.frequency === 'annual'" outlined class="mx-auto mb-0">
          <div>
            You have chosen an <span class="font-weight-bold text-decoration-underline">annual plan</span>.  You will be billed for the entire year at once.
          </div>
        </v-alert>
      </v-fade-transition>
    </template>

    <template v-if="!subscriptionChange" >
      <v-col :cols="12" class="text-center font-italic pa-2">
        "This is the <span class="font-weight-bold">most genius solution</span> I've ever seen."&nbsp;-&nbsp;Abigale&nbsp;W.
      </v-col>

      <v-col :cols="12" class="text-center font-italic pa-2">
        "This is the <span class="font-weight-bold">best app for family accountability</span>!"&nbsp;-&nbsp;Miranda&nbsp;S.
      </v-col>
    </template>
    <v-col :cols="12" class="pa-2" v-else>
      Subscription changes are pro-rated.  If you switch from an annual plan to a monthly plan, your account will be credited according to the remainder of the balance on the annual plan.  If you switch from a monthly plan to the annual plan, you'll pay a prorated amount.
    </v-col>
    <v-col :cols="12" class="" v-if="!$store.getters.isSubscribed">
      <p style="text-align: center;" class="ma-3" v-if="$store.getters.shouldGetFreeTrialDueToReferrer">14 day free trial</p>
      <p style="text-align: center;" class="ma-3" v-if="!$store.state.inApp"><i>30 day moneyback guarantee</i></p>

      <v-dialog v-model="showFreeTrialPopup" max-width="400">
        <v-card>
          <v-card-title>Congratulations!</v-card-title>
          <v-card-text>
            Subscribe now to get a 14 day free trial.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="showFreeTrialPopup = false" color="primary">
              Okay
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-col>
<!--    <v-col :cols="12" class="mt-2" v-else>-->
<!--      <p class="mb-2 caption font-italic">Subscription upgrades will result in a <span class="error&#45;&#45;text">prorated</span> charge, so your first charge after upgrading may be different from your regular charge.  This allows you to upgrade mid-bill cycle without having to worry about being charged any extra.</p>-->
<!--    </v-col>-->
    <v-col :cols="12" class="mt-5">
      <v-btn text color="secondary" @click="cancelClicked()">Cancel</v-btn>
      <v-btn id="continue-button" class="white--text" color="primary" @click="continueClicked()" style="float: right;" :disabled="!selectedPlan" :loading="continueLoading" >{{submitText}}</v-btn>
    </v-col>
  </v-row>
</template>

<script>
import DynamicPlans from "@/components/accounts/DynamicPlans";
import Utils from "@/Utils";
import StoreConstants from "@/StoreConstants";
import AndroidInterface from "@/services/AndroidInterface";

let animationInterval = null

  export default {
    name: "PlanSelection",
    created() {

      const loadLocalizedPricing = async () => {
        console.log('loadLocalizedPricing')
        if(AndroidInterface.shouldFetchLocalizedPricing()) {
          console.log('loadLocalizedPricing shouldFetchLocalizedPricing')
          await this.$store.state.accountLoadedPromise

          this.localizedAnnualPrice = await AndroidInterface.fetchLocalizedPricing(this.annualPlan.value.googlePlaySubscriptionId)
          this.localizedMonthlyPrice  = await AndroidInterface.fetchLocalizedPricing(this.monthlyPlan.value.googlePlaySubscriptionId)
        }
      }

      loadLocalizedPricing()

      animationInterval = setInterval(() => {
        if(this.loadingText.length >= 3) {
          this.loadingText = '.'
        } else {
          this.loadingText += '.'
        }
      }, 250)
    },

    beforeDestroy() {
      if(animationInterval !== null) {
        clearInterval(animationInterval)
        animationInterval = null
      }
    },
    props: {
      submitText: {
        type: String,
        default: 'Continue'
      },
      subscriptionChange: {
        type: Boolean,
        default: false
      },
      waitDuration: {
        type: Number,
        default: 5000
      }
    },
    data() {
      return {
        supportDomain: process.env.VUE_APP_SUPPORT_DOMAIN,
        loading: false,
        continueLoading: false,
        showFreeTrialPopup: false,
        annual: true,
        selectedPlan: null,
        localizedAnnualPrice: '',
        localizedMonthlyPrice: '',
        loadingText: '...'
      }
    },
    mounted() {
      this.showFreeTrialPopup = this.$store.getters.shouldGetFreeTrialDueToReferrer

      const handleOnlyAnnual = async () => {
        if(this.$store.state.onlyAnnual) {

          if(Date.now() - this.$store.state.onlyAnnual > 5 * 60 * 1000) {
            this.$store.commit(StoreConstants.commits.setOnlyAnnual, false)
            this.$store.commit(StoreConstants.commits.setCoupon)
            return
          }

          if(!this.$store.getters.termsAccepted) {
            console.log('onlyAnnual waiting for terms')
            await this.$store.state.termsAcceptedPromise
            console.log('onlyAnnual waiting for terms done')
          }

          this.planPicked(DynamicPlans.getAnnualPlans(process.env.VUE_APP_PRODUCT)[0])
          this.continueClicked()
        }
      }

      handleOnlyAnnual()
    },
    methods: {
      planPicked(plan) {
        if(!this.continueLoading) {
          console.log('plan picked')
          this.selectedPlan = plan.value
        }
      },
      async continueClicked() {
        this.continueLoading = true
        console.log(`choose ${this.selectedPlan}`)
        this.$emit('on-continue', this.selectedPlan)
        await Utils.sleep(120000) //wait 2 minutes, page should refresh itself
        this.continueLoading = false
      },
      cancelClicked() {
        this.$emit('on-cancel')
      }
    },
    computed: {
      annualPlan() {

        let productToLoad = process.env.VUE_APP_PRODUCT
        if(this.$store.getters.isSubscribed) {
          if(this.$store.state.account?.account?.product) {
            productToLoad = this.$store.state.account.account.product
          } else {
            productToLoad = 'truple'
          }
        }

        return DynamicPlans.getAnnualPlans(productToLoad)[0]
      },
      monthlyPlan() {
        let productToLoad = process.env.VUE_APP_PRODUCT
        if(this.$store.getters.isSubscribed) {
          if(this.$store.state.account?.account?.product) {
            productToLoad = this.$store.state.account.account.product
          } else {
            productToLoad = 'truple'
          }
        }

        return DynamicPlans.getMonthlyPlans(productToLoad)[0]
      },
      animatedLocalizedAnnualPrice() {
        if(AndroidInterface.shouldFetchLocalizedPricing()) {

          if(this.localizedAnnualPrice) {
            return this.localizedAnnualPrice
          } else {
            return this.loadingText
          }

        } else {
          return this.annualPlan.text
        }
      },
      animatedLocalizedMonthlyPrice() {
        if(AndroidInterface.shouldFetchLocalizedPricing()) {
          if(this.localizedMonthlyPrice) {
            return this.localizedMonthlyPrice
          } else {
            return this.loadingText
          }
        } else {
          return this.monthlyPlan.text
        }
      }
    }
  }
</script>

<style scoped lang="scss">

.plan-type {
  background-color: $theme-secondary;
  color: $theme-secondary;
  border-top-left-radius: 5px !important;
  border-top-right-radius: 5px !important;

  &.chosen {
    background-color: $theme-primary;
    color: $theme-primary;
  }

  &.loading {
    border: 2px solid $theme-secondary !important;
  }
}

.accent-border {
  height: 90px;
  border: 2px solid $theme-secondary !important;
  color: $theme-secondary;
  border-bottom-left-radius: 5px !important;
  border-bottom-right-radius: 5px !important;

  &.chosen {
    border: 2px solid $theme-primary !important;
    color: $theme-primary;
  }

  &.loading {
    border: 2px solid $theme-secondary !important;
  }
}

</style>
